import { render, staticRenderFns } from "./TakeOffBarber.vue?vue&type=template&id=62e07776&scoped=true"
import script from "./TakeOffBarber.vue?vue&type=script&lang=js"
export * from "./TakeOffBarber.vue?vue&type=script&lang=js"
import style0 from "./TakeOffBarber.vue?vue&type=style&index=0&id=62e07776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e07776",
  null
  
)

export default component.exports